import {
  getUserInfo,
  postContactDetails,
  postConversation,
  userLogin,
} from "../services";
import {
  ContactFormType,
  ConversationType,
  UserInfoType,
  UserLoginType,
  UserResponseType,
} from "../../types/types";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";

export const useSubmitContactDetails = <
  TError = AxiosError,
  TContext = unknown
>(
  options?: UseMutationOptions<unknown, TError, ContactFormType, TContext>
) => {
  return useMutation<unknown, TError, ContactFormType, TContext>(
    ["contactForm"],
    postContactDetails<unknown, ContactFormType>(),
    options
  );
};

export const useUserLogin = <TError = AxiosError, TContext = unknown>(
  options?: UseMutationOptions<
    UserResponseType,
    TError,
    UserLoginType,
    TContext
  >
) => {
  return useMutation<UserResponseType, TError, UserLoginType, TContext>(
    ["userLogin"],
    userLogin<UserResponseType, UserLoginType>(),
    options
  );
};

export const useGetUserInfo = <TError = AxiosError, TContext = unknown>(
  options?: UseMutationOptions<UserInfoType, TError, string, TContext>
) => {
  return useMutation<UserInfoType, TError, string, TContext>(
    ["getUserInfo"],
    getUserInfo<UserInfoType, string>(),
    options
  );
};

export const useConversation = <TError = AxiosError, TContext = unknown>(
  options?: UseMutationOptions<ConversationType, TError, string, TContext>
) => {
  return useMutation<ConversationType, TError, string, TContext>(
    ["conversation"],
    postConversation<ConversationType, string>(),
    options
  );
};
